import './ComponentGroupField.css';

export default function ComponentGroupField({value, groups, onChange}) {
  return <div className="component-group-field">
    <label htmlFor="component-group-input">Component group (optional)</label>
    <input id="component-group-input" type="text" list="component-group-suggestions" autoComplete="off" value={value} aria-describedby="component-group-help" onInput={(event) => onChange(event.currentTarget.value)} />
    <datalist id="component-group-suggestions">
      {groups.map((name) => <option key={name} value={name} />)}
    </datalist>
    <div id="component-group-help">Choose an existing group or enter a new name. Leave blank for no group.</div>
  </div>;
}
